// extracted by mini-css-extract-plugin
module.exports = {"labels":"styles_labels__3WBHb"};